import React, {ChangeEvent} from "react";
import {IntlMessageValue, UniCol, UniForm, UniRow} from "../../../../../@WUM/core/Elements";
import UniChecks from "../../../../../@WUM/core/Elements/Form/Elements/Check";

interface AllowFlexitimeProps {
    value: any;
    onChange: (data: { name: string; value: string | boolean }) => void;
}


const AllowFlexitime = (Props: AllowFlexitimeProps) => {

    const handleSwitch = (event: ChangeEvent<Element>) => {
        const target = event.target as HTMLInputElement;
        Props.onChange({name: target.name, value: target.checked});
    };

    const handleInput = (event: ChangeEvent<Element>) => {
        const target = event.target as HTMLInputElement;
        Props.onChange({name: target.name, value: target.value});
    };

    const allow =
        Props.value?.flexitime?.allowFlexitime ??
        Props.value?.allowFlexitime ??
        false;


    return (
        <>
            <div className={""}>
                <div>
                    <UniChecks
                        type="switch"
                        label={IntlMessageValue("", "time.settings.allow-flexitime", "")}
                        name="allowFlexitime"
                        checked={Props?.value?.allowFlexitime}
                        class={"uni-switch ps-0 mb-3"}
                        onChange={handleSwitch}
                        info={{text: "time.settings.allow-flexitime.helper"}}
                    />
                </div>
                {allow && (
                    <UniRow>
                        <UniCol>
                            <UniForm.InputGroup class={"mb-md-0 mb-3"}>
                                <UniForm.InputGroupText class={""}
                                                        text={IntlMessageValue("", "time.settings.flexitime-start", "")}/>
                                <UniForm.FormControl
                                    type="time"
                                    name="flexitime-start"
                                    defaultValue={Props?.value?.flexitimeStart}
                                    required
                                    onChange={handleInput}
                                />
                                <UniForm.InputGroupHelpText text={"time.settings.flexitime-start.helper"}
                                                            class={"p-0 pe-1"} Store={""}/>
                            </UniForm.InputGroup>
                        </UniCol>
                        <UniCol>

                            <UniForm.InputGroup class={"mb-md-0 mb-3"}>

                                <UniForm.InputGroupText class={""}
                                                        text={IntlMessageValue("", "time.settings.flexitime-end", "")}/>
                                <UniForm.FormControl
                                    type="time"
                                    name="flexitime-end"
                                    defaultValue={Props?.value?.flexitimeEnd}
                                    required
                                    onChange={handleInput}
                                />
                                <UniForm.InputGroupHelpText text={"time.settings.flexitime-end.helper"}
                                                            class={"p-0 pe-1"} Store={""}/>

                            </UniForm.InputGroup>
                        </UniCol>
                    </UniRow>
                )}

            </div>

        </>
    )
}
export default AllowFlexitime;
